
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getDataList:`post ${process.env.VUE_APP_API_ROOT}plate/queryDemandList.htm `,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"magicServicePage"
			})
		}